import axios from "axios";

export default function getCreditOverview() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/campaignV2/customer/company/overview`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
